import React from 'react';
import { DateTime } from 'luxon';

// import components
import EventCardsGrid from 'components/partials/event-cards-grid';

// import types
import { EventCardSmallProps } from "components/partials/parts/event-card-small";

// import helpers
import { isGatsbyImageData } from "helpers/is-gatsby-image";
import { getLinkById } from 'hooks/use-generate-site-link';

const FeaturedEventsBuilder: React.FC<{ featuredEventsBlockData?: Queries.FeaturedEventsBlockFragment }> = ({ featuredEventsBlockData }) => {

    if (!featuredEventsBlockData) return null;

    const intro = {
        headline: featuredEventsBlockData.heading || 'Error: Missing headline'
    };

    let patternClass = featuredEventsBlockData.colorOption ? `bg-brand-${featuredEventsBlockData.colorOption}` : 'bg-brand-orange';

    const cards: EventCardSmallProps[] = featuredEventsBlockData.events?.map((event): EventCardSmallProps | undefined => {
        if (!event) return undefined;

        let eventUrl = getLinkById(event.id) || '#';

        // get the startdate object
        let startDate = event.startDatetime 
            ? DateTime.fromISO(event.startDatetime, {zone: 'America/Los_Angeles'}) 
            : DateTime.now().setZone('America/Los_Angeles').startOf('day');
        
        // get the enddate object
        let endDate = event.endDatetime 
            ? DateTime.fromISO(event.endDatetime, {zone: 'America/Los_Angeles'}) 
            : null;

        let cardDateTime: DateTime|string = startDate;
        
        if (startDate && endDate) {
            cardDateTime = `${startDate.toFormat('cccc, LLL d')} - ${endDate.toFormat('cccc, LLL d')}`;
        }

        // Display event date range instead of start datetime if we can, per client request
        let cardImage = undefined;
        if (event.heroImage && typeof event.heroImage === 'object') {
            cardImage = isGatsbyImageData(event.heroImage.gatsbyImageData) ? event.heroImage.gatsbyImageData : undefined;
        }

        let cardImageAlt = event.heroImage?.alt || '';

        return {
            title: event.title || 'Error: Missing title',
            dateTime: cardDateTime,
            linkUrl: eventUrl,
            image: cardImage,
            imageAlt: cardImageAlt
        };
    }).filter(card => card !== undefined) as EventCardSmallProps[] || [];

    return (
        cards.length > 0 ? (
            <EventCardsGrid
                patternClass={patternClass}
                intro={intro}
                cards={cards}
            />
        ) : null
    );
};

export default FeaturedEventsBuilder;